import { ESdChangeReason } from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";

/** How long a recurring action waits between runs, in seconds: anything up to a day. */
const RECURRING_INTERVAL_MIN_SECONDS: number = 0;
const RECURRING_INTERVAL_MAX_SECONDS: number = 86400;

export interface IRecurringActionInputState {}

export interface IRecurringActionInputProps {
  recurringInterval?: number;
  onChange?: (recurringInterval) => void;
}

class RecurringActionInput extends PureSdComponent<
  IRecurringActionInputProps & IWithSDProps & IWithContextProp,
  IRecurringActionInputState
> {
  constructor(props: IRecurringActionInputProps & IWithSDProps & IWithContextProp) {
    super(props);
  }

  waitAndChange = _.debounce((value) => {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }, 20);

  clearInput = () => {
    this.waitAndChange("");
  };

  handleBlur = (event: React.FocusEvent<HTMLInputElement>): void => {
    let value: number = parseInt(event.target.value);
    if (value > RECURRING_INTERVAL_MAX_SECONDS) {
      value = RECURRING_INTERVAL_MAX_SECONDS;
    } else if (value < RECURRING_INTERVAL_MIN_SECONDS) {
      value = RECURRING_INTERVAL_MIN_SECONDS;
    }
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  render() {
    return (
      <>
        <div className="kuika-right-panel__row" style={{ marginTop: 8, marginBottom: 4 }}>
          <div className="kuika-right-panel__col">Recurring Time(sec)</div>
        </div>
        <div className="kuika-right-panel__row" style={{ marginBottom: 8 }}>
          <div className="kuika-right-panel__col">
            {/* The field clamps to the same range the handler does, so what it shows after
                leaving it is what gets saved. antd clamped to a floor of 1 on screen while its own
                blur handler, which runs first, kept a 0 — so a 0 read as 1 and saved as 0. The
                class stays: the action panel scrolls the field into view by it. */}
            <KuikaInput
              type="number"
              className="kuika_recurring_property"
              defaultValue={this.props.recurringInterval ?? 0}
              min={RECURRING_INTERVAL_MIN_SECONDS}
              max={RECURRING_INTERVAL_MAX_SECONDS}
              onBlur={this.handleBlur}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock
    ) {
      return true;
    }
    return false;
  };
}

const recurringActionInput = withContext<IRecurringActionInputProps>(
  withSD<IRecurringActionInputProps>(RecurringActionInput)
);
export { recurringActionInput as RecurringActionInput };
